import { View, Text } from "react-native";
import { ActionRowCard } from "@louise/moon-ui";
import { EMBER } from "../../onboarding/theme";
import { OrganicMiniIcon } from "@src/packages/homepage/plan/components/OrganicMiniIcon";
import type { Article } from "./ArticleSectionCard";

export default function ArticleBannerCard({
  label,
  article,
  onPress,
  topSpacing = 20,
}: {
  label?: string;
  article: Article;
  onPress?: () => void;
  topSpacing?: number;
}) {
  return (
    <View style={{ marginTop: topSpacing }}>
      {label ? (
        <View className="mb-3 flex-row items-center justify-between px-1">
          <Text
            className="font-dm-sans"
            style={{
              fontSize: 11,
              fontWeight: "600",
              color: EMBER.colors.textFaint,
              letterSpacing: 1,
              textTransform: "uppercase",
            }}
          >
            {label}
          </Text>
        </View>
      ) : null}

      <ActionRowCard
        leading={<OrganicMiniIcon kind="learn" size={30} />}
        title={article.title}
        subtitle={article.teaser}
        onPress={onPress}
        accessibilityLabel={`${article.title}. ${article.teaser}`}
      />
    </View>
  );
}
